var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1669 7.97729C19.2081 6.80139 18.9472 5.63428 18.4085 4.58435C18.043 4.15353 17.5358 3.8628 16.9752 3.76281C14.6565 3.55539 12.3281 3.47038 10.0002 3.50813C7.68072 3.46867 5.36078 3.55094 3.05019 3.75459C2.59337 3.83652 2.17062 4.04775 1.83352 4.36253C1.08352 5.04441 1.00019 6.21099 0.916852 7.19683C0.795945 8.96935 0.795945 10.7479 0.916852 12.5204C0.94096 13.0753 1.02476 13.626 1.16685 14.1635C1.26733 14.5784 1.47062 14.9623 1.75852 15.2807C2.09791 15.6122 2.53051 15.8354 3.00019 15.9215C4.79678 16.1402 6.60703 16.2308 8.41685 16.1926C11.3335 16.2337 13.8919 16.1926 16.9169 15.9626C17.3981 15.8818 17.8428 15.6583 18.1919 15.3218C18.4252 15.0917 18.5994 14.8101 18.7002 14.5003C18.9982 13.5987 19.1446 12.6552 19.1335 11.7071C19.1669 11.247 19.1669 8.47021 19.1669 7.97729ZM8.11685 12.2V7.11468L13.0502 9.66965C11.6669 10.4255 9.84185 11.2799 8.11685 12.2Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.50d04b379f742e70e67d9e45faccd490.svg";
export { ForwardRef as ReactComponent };